import { CommonViewController } from '../../controller/CommonViewController';
import { REACT_AH_DATA_READY } from '../../components/react/AwApplicationHeaderHelpers/AwApplicationHeaderHelpers';

export const DASHBOARDROUTE = 'app.dashboard';
export const DASHBOARDTITLE = 'DASHBOARD';
export const CONSOLIDATION_CURRENCY = 'consolidationCurrency';
export const DEF_CURRENCY = { code: 'CHF', name: '', currency: 'CHF'};

/** @ngInject */
export class DashBoardController extends CommonViewController {
    constructor($scope, userService, arsMainDependencies, $window) {
        super($scope, userService, arsMainDependencies);
        this.$rootScope.$on(REACT_AH_DATA_READY, () => {
            let portalNew = this.ftsMainDependencies.applications.filter(app => app.name==='FidesPortal')[0];
            let dest = portalNew.url;
            if(!dest.includes('portal')) {
                dest = dest + '/portal';
            }
            $window.location.href = dest + '/app/dashboard';
        });
    }
}
